export const BASE_URL = "https://management.pjconstructiondesign.com/";
export const API_BASE_URL = "https://management.pjconstructiondesign.com/backend/api";
export const SITE_BASE_URL = "https://pjconstructiondesign.com";

export const API_TIMEOUT_MS = 15000;
